<template>
    <div class="nutrition">
        <div style="color: red">
            请核对信息与「对应识别图片」中包含信息一致，此模块信息直接在前端展示给用户
        </div>
        <div>
            营养成分表国家标准示例
            <mc-link path="https://p0.meituan.net/mallimages/9b653d673b818bb5af9c38558cb1d532178141.png">
                查看示例
            </mc-link>
        </div>

        <mc-loading
            v-if="loading"
            style="width:500px"
        />

        <div v-else>
            <div
                v-for="(innerItem,innerIndex) in nutritions"
                :key="innerItem.uuId"
                class="nutrition-facts"
            >
                <div
                    class="nutrition-facts-item"
                    :style="`width: ${Object.keys(itemLabelMap).length ? '1108px' :'960px'}`"
                >
                    <mc-link
                        style="margin-right: 10px"
                        @click="handleCopyNutrition(innerIndex)"
                    >
                        从剪贴板填充营养成分表
                    </mc-link>
                    <mc-configform
                        ref="configForm"
                        v-model="innerValue[innerIndex]"
                        :fields="nutritionFactsFieldsFilter"
                        :disabled="disabled"
                    >
                        <template slot="nutritions">
                            <div
                                v-if="innerItem.nutritions && innerItem.nutritions.headers"
                                class="nutritions-items"
                            >
                                <div
                                    v-for="(headersItem,headersIndex) in innerItem.nutritions.headers"
                                    :key="headersIndex"
                                    class="item"
                                >
                                    <div
                                        v-if="!headersIndex"
                                        class="item project-item-headers"
                                    >
                                        项目
                                    </div>
                                    <div
                                        v-else-if="headersIndex > 2"
                                        class="w-130"
                                        style="font-weight: bold"
                                    >
                                        营养成分含量程度
                                    </div>
                                    <mc-input
                                        v-else
                                        v-model="innerValue[innerIndex].nutritions.headers[headersIndex]"
                                        class="w-130"
                                    />
                                </div>
                            </div>

                            <div
                                v-for="(itemsItem,itemsIndex) in innerItem.nutritions.items"
                                :key="itemsItem.uuId"
                            >
                                <div class="nutritions-items mt-20">
                                    <div
                                        v-if="itemsItem.parentItem"
                                        class="parentItem"
                                    ></div>
                                    <div
                                        v-for="(detailsItem,detailsIndex) in itemsItem.details"
                                        :key="detailsIndex"
                                        class="item"
                                    >
                                        <div
                                            v-if="detailsIndex > 2"
                                            class="w-130"
                                            style="font-weight: bold"
                                        >
                                            {{ detailsItem }}
                                        </div>
                                        <mc-input
                                            v-else
                                            v-model="innerValue[innerIndex].nutritions.items[itemsIndex].details[detailsIndex]"
                                            :class="inputClass(detailsIndex, itemsItem.parentItem)"
                                            @change="(val)=>handleItemDetailChange(val,innerIndex,itemsIndex,detailsIndex)"
                                        />
                                    </div>

                                    <McOptionButtons
                                        :source="{innerIndex,itemsIndex}"
                                        :button-render="buttonRender"
                                    />
                                </div>

                                <div
                                    v-show="ingredient(itemsItem.parentItem,itemsItem.details[0])"
                                    style="color:red;margin-bottom: -20px"
                                >
                                    {{ ingredient(itemsItem.parentItem,itemsItem.details[0]) }}
                                </div>
                            </div>
                        </template>
                    </mc-configform>
                </div>

                <mc-button
                    type="primary"
                    :disabled="disabled"
                    @click="handleAddOrDelete(innerIndex)"
                >
                    {{ innerIndex ? '删除' : '新增' }}
                </mc-button>

                <div
                    v-if="usePicUrl && !innerIndex"
                    style="margin-left:20px; text-align: center;"
                >
                    <mc-image
                        style="width: 100px; height: 100px"
                        :src="usePicUrl"
                        @click="handleShowOcrResult(usePicUrl)"
                    />
                    <div>对应识别的图片</div>

                    <mc-button
                        v-if="!disabled"
                        type="primary"
                        :disabled="ocrResultDrawerVisible"
                        @click="handleChangeIdentifyImg"
                    >
                        重新选择识别图片
                    </mc-button>
                </div>
            </div>
        </div>

        <OcrResultDrawer
            v-model="ocrResultDrawerVisible"
            :ocr-result="ocrResult"
            :image-src="usePicUrl"
        />
    </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import OcrResultDrawer from 'components/OcrResultDrawer';
import {
    computed, getCurrentInstance, ref, watch,
} from '@vue/composition-api';
import { cloneDeep, hPost, getCookie } from '@mcfe/tools';
import { reportLx } from '@lsfe/tools';
import { defaultNutritions, defaultNutritionsItems } from './config';

const nutritionFactsFields = Object.freeze([
    {
        label: '子商品名称',
        prop: 'productName',
    },
    {
        label: '营养成分表',
        slot: 'nutritions',
    },
]);

export default {
    components: {
        OcrResultDrawer,
    },
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        usePicUrl: {
            type: String,
            default: '',
        },
        itemLabelMap: {
            type: Object,
            default: () => ({}),
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance();

        const innerValue = computed({
            get() {
                return props.value;
            },
            set(val) {
                proxy.$emit('input', val);
            },
        });

        const nutritions = computed(() => {
            if (Object.keys(props.itemLabelMap).length === 0) return innerValue.value;
            return innerValue.value.map((item) => ({
                ...item,
                nutritions: {
                    headers: [...item.nutritions.headers, ''],
                    items: item.nutritions.items.map((itemsItem) => ({
                        ...itemsItem,
                        details: [...itemsItem.details, props.itemLabelMap[itemsItem.itemName] || '-'],
                    })),
                },
            }));
        });

        // 根据 innerValue 动态过滤 fields
        const nutritionFactsFieldsFilter = computed(() => {
            if (nutritions.value.length === 1) {
                return nutritionFactsFields.filter((field) => field.prop !== 'productName');
            }
            return nutritionFactsFields;
        });

        // 监听 innerValue 变化，当只剩一个时清空子商品名称
        watch(innerValue, (newVal) => {
            if (newVal.length === 1) {
                newVal.forEach((item) => {
                    if (item.productName) {
                        item.productName = '';
                    }
                });
            }
        }, { deep: true });

        const nutritionsFirstName = ref([]); // 营养成分表一级元素
        const nutritionsSecondName = ref([]); // 营养成分表二级元素
        const ocrResultDrawerVisible = ref(false); // ocr识别结果弹窗
        const ocrResult = ref({}); // 识别坐标

        /*
        * 处理输入框变化
        * @param {string} val - 用户输入的新值（项目名称）
        * @param {number} innerIndex - 当前营养成分表的索引（第几个营养成分表）
        * @param {number} itemsItem - 当前项目在数组中的索引（第几行）
        * @param {number} detailsIndex - 当前输入框在项目中的索引（0=项目名）
        * change的时候同步同步数组的第一项值parentItem 通过parentItem是否是二级元素
        */
        const handleItemDetailChange = (val, innerIndex, itemsItem, detailsIndex) => {
            if (detailsIndex) return;
            innerValue.value[innerIndex].nutritions.items[itemsItem].itemName = val;

            // 如果不是一级全部设置成二级
            if (!nutritionsFirstName.value.includes(val)) {
                // 找到上级元素（前一个非空的 itemName）
                let parentItem = '';
                // 向前遍历，找到最近的非空项目作为上级
                for (let i = itemsItem - 1; i >= 0; i--) {
                    const prevItem = innerValue.value[innerIndex].nutritions.items[i];
                    if (prevItem && prevItem.itemName) {
                        // 如果前一项是二级，用它的上级；如果是一级，用它的名称
                        parentItem = prevItem.parentItem || prevItem.itemName;
                        break;
                    }
                }
                // 设置当前项目为二级元素
                innerValue.value[innerIndex].nutritions.items[itemsItem].parentItem = parentItem;
            } else {
                // 是一级元素，parentItem 置空
                innerValue.value[innerIndex].nutritions.items[itemsItem].parentItem = '';
            }

            if (innerValue.value[innerIndex].nutritions.items[itemsItem + 1] && innerValue.value[innerIndex].nutritions.items[itemsItem + 1].parentItem) {
                innerValue.value[innerIndex].nutritions.items[itemsItem + 1].parentItem = val;
            }
            proxy.$emit('change');
        };
        const ingredient = computed(() => (parentItem, item) => {
            if (parentItem && nutritionsFirstName.value.includes(item)) return '根据国家标准，系统建议调整为一级元素，实际请与实物图片保持一致';
            if (!parentItem && nutritionsSecondName.value.includes(item)) return '根据国家标准，系统建议调整为二级元素，实际请与实物图片保持一致';
            return '';
        });

        const buttonRender = ({ innerIndex, itemsIndex }) => {
            const nutritionsItems = innerValue.value[innerIndex].nutritions.items;
            return [{
                label: nutritionsItems[itemsIndex].parentItem ? '切换一级' : '切换二级',
                type: 'button',
                permission: !!itemsIndex && !props.disabled,
                clickFn: () => {
                    const currentItem = nutritionsItems[itemsIndex];
                    const previousItem = nutritionsItems[itemsIndex - 1];
                    if (!previousItem.itemName) {
                        proxy.$mc.message.error('上级名称必填');
                        return;
                    }
                    nutritionsItems[itemsIndex].parentItem = currentItem.parentItem ? '' : previousItem.parentItem || previousItem.itemName;
                },
            }, {
                label: '新增',
                type: 'button',
                permission: !props.disabled,
                clickFn: () => {
                    nutritionsItems.splice(itemsIndex + 1, 0, defaultNutritionsItems());
                },
            }, {
                label: '删除',
                type: 'button',
                permission: !!itemsIndex && !props.disabled,
                clickFn: () => {
                    nutritionsItems.splice(itemsIndex, 1);
                },
            }, {
                label: '上移',
                type: 'button',
                permission: !!itemsIndex && !props.disabled,
                clickFn: () => {
                    if (itemsIndex === 1 && nutritionsItems[itemsIndex].parentItem) {
                        proxy.$mc.message.error('二级成分不能成为第一项');
                        return;
                    }
                    const item = cloneDeep(nutritionsItems[itemsIndex]);
                    nutritionsItems.splice(itemsIndex, 1);
                    nutritionsItems.splice(itemsIndex - 1, 0, item);
                },
            }, {
                label: '下移',
                type: 'button',
                permission: nutritionsItems.length - 1 !== itemsIndex && !props.disabled,
                clickFn: () => {
                    const item = cloneDeep(nutritionsItems[itemsIndex]);
                    nutritionsItems.splice(itemsIndex, 1);
                    nutritionsItems.splice(itemsIndex + 1, 0, item);
                },
            }];
        };

        const handleAddOrDelete = (innerIndex) => {
            proxy.$emit('change');
            if (!innerIndex) {
                innerValue.value.push(defaultNutritions());
                return;
            }
            innerValue.value.splice(innerIndex, 1);
        };

        // 获取配置的一级二级元素
        const getNutritionsName = async () => {
            const res = await hPost('/api/m/tms/mapi/dictionary/batchGetDictionaryAndValue', {
                dicCodes: ['special:product:nutritions_second_name', 'special:product:nutritions_first_name'],
            });
            nutritionsFirstName.value = (res['special:product:nutritions_first_name']?.dictionaryValueList || []).map((item) => item.name);
            nutritionsSecondName.value = (res['special:product:nutritions_second_name']?.dictionaryValueList || []).map((item) => item.name);
        };

        // 重新选择识别图片
        const handleChangeIdentifyImg = () => {
            proxy.$emit('changeIdentifyImg', 'nutritions');
        };

        getNutritionsName();

        // 点击图片
        const handleShowOcrResult = async (picUrl) => {
            reportLx('moduleClick', 'b_chaoshi_w72djl8r_mc', { msid: getCookie('msid') || '' }, { cid: 'c_chaoshi_wg348euq' });
            const res = await hPost('/api/vss/shepherd/ProductAlgToolTService/getCachedOcrText', { picUrl });
            ocrResult.value = JSON.parse(res);
            ocrResultDrawerVisible.value = true;
        };

        const handleCopyNutrition = async (innerIndex) => {
            reportLx('moduleClick', 'b_chaoshi_otxm1b8w_mc', { msid: getCookie('msid') || '' }, { cid: 'c_chaoshi_wg348euq' });
            try {
                // 从剪贴板读取文本
                const clipboardText = await navigator.clipboard.readText();
                // 解析剪贴板数据
                const parsedData = JSON.parse(clipboardText);

                // 获取现有的营养成分表数据
                const updatedNutrition = innerValue.value[innerIndex];

                // 如果headers还没有设置，则初始化它
                if (!updatedNutrition.nutritions.headers || !updatedNutrition.nutritions.headers.length) {
                    updatedNutrition.nutritions.headers = ['项目', '含量', '营养素参考值(NRV%)'];
                }

                // 确保items数组存在
                if (!updatedNutrition.nutritions.items) {
                    updatedNutrition.nutritions.items = [];
                }

                // 按照3个元素一组处理数据并追加
                for (let i = 0; i < parsedData.length; i += 3) {
                    const item = defaultNutritionsItems();
                    item.details[0] = parsedData[i] || '';
                    item.details[1] = parsedData[i + 1] || '';
                    item.details[2] = parsedData[i + 2] || '';
                    item.itemName = item.details[0];

                    // 只添加有效行（第一列不为空的行）
                    if (item.details[0]) {
                        updatedNutrition.nutritions.items.push(item);
                    }
                }

                // 触发更新
                innerValue.value = [...innerValue.value];
                proxy.$mc.message.success('营养成分表数据已追加');
                proxy.$emit('change');
            } catch (error) {
                proxy.$mc.message.error('剪贴板数据格式不正确');
            }
        };

        const inputClass = (detailsIndex, parentItem) => {
            if (detailsIndex === 0 && parentItem) return 'w-160';
            if (detailsIndex === 0) return 'w-project';
            return 'w-130';
        };

        return {
            nutritionFactsFields,
            nutritionFactsFieldsFilter,

            innerValue,
            nutritionsFirstName,
            nutritionsSecondName,
            nutritions,
            handleItemDetailChange,
            buttonRender,
            handleAddOrDelete,
            ingredient,
            handleChangeIdentifyImg,
            handleShowOcrResult,
            ocrResultDrawerVisible,
            ocrResult,
            handleCopyNutrition,
            inputClass,
        };
    },

};
</script>

<style lang="scss" scoped>
.nutrition {
    .nutrition-facts {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .nutrition-facts-item {
            padding: 10px 10px 0 0px;
            border-radius: 10px;
            border: 1px solid #e0e0e0;
            margin-right: 30px;
            width: 1025px;
            .nutritions-items {
                display: flex;
                align-items: center;
                .item {
                    text-align: center;
                    padding: 0 10px;
                }
                .project-item-headers{
                    width: 190px;
                }
                .parentItem {
                    height: 1px;
                    width: 20px;
                    background-color: #000;
                    margin-left: 10px;
                }
            }
            .mt-20 {
                margin-top: 20px;
            }
        }
    }
    .nutrition-facts:last-child {
        margin-bottom: 0px;
    }
    .w-130 {
        width: 130px;
        ::v-deep .mtd-input-wrapper{
            width: 130px;
            text-align: center;
        }
    }
    .w-160 {
        width: 160px;
        ::v-deep .mtd-input-wrapper{
            width: 160px;
            text-align: center;
        }
    }
    .w-project {
        width: 190px;
        ::v-deep .mtd-input-wrapper{
            width: 190px;
            text-align: center;
        }
    }
}

</style>
